export const I18n = {
    promoterTitleBeginning: 'Promoter / ',
    'en': {
        modal: {
            upload: 'Upload',
            delete: 'Delete',
            sure: 'Are you sure?',
            cancel: 'Cancel',
            save: 'Save',
            addOrEditCategory: 'Add / Edit category',
            addOrEditSection: 'Add / Edit section',
            addOrEditVideo: 'Add / Edit video',
            shared: 'Shared',
            showPriceTag: 'Show price tag',
            downloadCsv: 'Download CSV',
            loadFromCsv: "Load from CSV",
            notFoundSalesPoints: 'Not found sales points',
        },
        all: 'All',
        company: 'Company',
        videoOwner: 'Video owner',
        store: 'Store',
        stores: 'Stores',
        filter: "Filtering",
        resetFilters: 'Reset filters',
        searchPlaceholder: 'Search...',
        searchVideo: 'Search video',
        searchStore: 'Search store',
        dateFrom: 'From Date',
        dateTo: 'To Date',
        asc: 'Ascending',
        desc: 'Descending',
        category: 'Category',
        section: 'Section',
        video: 'Video',
        mediaLibrary: 'Media library',
        activeDevices: 'Active devices',
        numberOfDevices: 'Number of devices',
        videoImpressions: 'Video impressions',
        impressionsByStores: 'Impressions by stores',
        playbackReport: 'Playback report',
        storePlaybackReport: 'Store playback report',
        totalDuration: 'Total duration',
        categories: 'Categories',
        sections: 'Sections',
        addCategory: 'Add category',
        addSection: 'Add section',
        addVideo: 'Add video',
        categoryAlreadyExists: 'A category with the same name already exists.',
        sectionAlreadyExists: 'A section with the same name already exists in the selected category',
        videoAlreadyExists: 'A video with the same name already exists in the selected section',
        name: 'Name',
        choose: "Choose",
        thisFieldCanNotBeEmpty: "This field cannot be empty",
        durationFormat: '%d h %d min %d sec',
        reset: 'Reset',
        settings: 'Settings',
        timeFormatPlaceholder: 'HH:mm',
        appTurnOnTime: 'Application turn-on time',
        appTurnOffTime: 'Application turn-off time',
        priceTagUrl: 'Price tag URL',
        screenBrightness: 'Player screen brightness',
        contactUsToAccessThis: 'Contact info@hankuper.com to access this functionality',
        tags: 'Tags',
        playOnFaceDetect: 'Play on face detect',
        minutesBetweenPlays: 'Minutes between plays',
        turnOnTime: 'Turn-on time',
        turnOffTime: 'Turn-off time',
        allOrNonePlaybackSettingsMustBeSpecified: 'All or none of the playback settings must be specified',
        size: 'Size',
        loadingDate: 'Loading date',
        totalMemoryUsage: 'Total memory usage:'
    },
    'ru': {
        modal: {
            upload: 'Загрузить',
            delete: 'Удалить',
            sure: 'Вы уверены?',
            cancel: 'Отмена',
            save: 'Сохранить',
            addOrEditCategory: 'Добавить / Изменить категорию',
            addOrEditSection: 'Добавить / Изменить раздел',
            addOrEditVideo: 'Добавить / Изменить видео',
            shared: 'Общая',
            showPriceTag: 'Показывать ценник',
            downloadCsv: 'Выгрузить в CSV',
            loadFromCsv: "Загрузить из CSV",
            notFoundSalesPoints: 'Не найденные торговые точки',
        },
        all: 'Все',
        company: 'Компания',
        videoOwner: 'Владелец видео',
        store: 'Магазин',
        stores: 'Магазины',
        filter: "Применить фильтры",
        resetFilters: 'Сбросить фильтры',
        searchPlaceholder: 'Поиск...',
        searchVideo: 'Поиск видео',
        searchStore: 'Поиск магазина',
        dateFrom: 'C даты',
        dateTo: 'По дату',
        asc: 'По возрастанию',
        desc: 'По убыванию',
        category: 'Категория',
        section: 'Раздел',
        video: 'Видео',
        mediaLibrary: 'Библиотека медиа',
        activeDevices: 'Активные устройства',
        numberOfDevices: 'Количество устройств',
        videoImpressions: 'Показы видео',
        impressionsByStores: 'Показы по магазинам',
        playbackReport: 'Отчет о воспроизведении',
        storePlaybackReport: 'Отчет по магазинам',
        totalDuration: 'Общая продолжительность',
        categories: 'Категории',
        sections: 'Разделы',
        addCategory: 'Добавить категорию',
        addSection: 'Добавить раздел',
        addVideo: 'Добавить видео',
        categoryAlreadyExists: 'Категория с таким названием уже существует',
        sectionAlreadyExists: 'Раздел с таким названием уже существует в выбранной категории',
        videoAlreadyExists: 'Видео с таким названием уже есть в выбранном разделе',
        name: 'Имя',
        choose: "Выбрать",
        thisFieldCanNotBeEmpty: "Это поле не может быть пустым",
        durationFormat: '%d ч %d мин %d сек',
        reset: 'Сбросить',
        settings: 'Настройки',
        timeFormatPlaceholder: 'HH:mm',
        appTurnOnTime: 'Время включения приложения',
        appTurnOffTime: 'Время выключения приложения',
        priceTagUrl: 'URL-адрес ценника',
        screenBrightness: 'Яркость экрана плеера',
        contactUsToAccessThis: 'Для доступа к данному функционалу - обратитесь по адресу info@hankuper.com',
        tags: 'Теги',
        playOnFaceDetect: 'Проигрывать при распознавании лица',
        turnOnTime: 'Время включения',
        turnOffTime: 'Время выключения',
        minutesBetweenPlays: 'Минут между запусками',
        allOrNonePlaybackSettingsMustBeSpecified: 'Должны быть заданы все или никакие параметры воспроизведения',
        size: 'Размер',
        loadingDate: 'Дата загрузки',
        totalMemoryUsage: 'Всего использовано памяти:'
    },
};


// WEBPACK FOOTER //
// ./src/I18n/components/promoter/index.js